module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "otherDetail"
  }, [_c('div', {
    staticClass: "des",
    domProps: {
      "innerHTML": _vm._s(_vm.otherDetail.content)
    }
  }), _vm._v(" "), (_vm.otherDetail.image_list.length > 0) ? _c('div', {
    staticClass: "page-num"
  }, [_vm._v(_vm._s(_vm.pictureIndex) + " / " + _vm._s(_vm.pictureTotal))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.otherDetail.image_list), function(item) {
    return _c('div', {
      staticClass: "swiper-slide",
      style: ({
        backgroundImage: 'url(' + item + ')'
      })
    })
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-e188b9da","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/OtherDetail.vue
// module id = 460
// module chunks = 7